import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { ConfirmationModal } from '../../../../subcomponents/confirmation-modal/confirmation-modal';
import { extractLastDigitsFromMaskedCardNumber } from '../../../../utils/extract-last-digits-from-masked-card-number';
import { reactivateSubscription } from '../../actions/reactivate-subscription';
import { MemberPaymentCardWalletContextInstance } from '../../types/context';
import { getFormattedMessage } from '../../utils/get-formatted-message';
export const MemberPaymentCardWalletReactivateModal = observer(props => {
    const i18n = useI18n();
    const { show, primaryCard, reactivationPrice, hideModal, onActionStarted, onActionFinished } = props;
    const { displayText } = useContext(MemberPaymentCardWalletContextInstance);
    const { reactivateSubscriptionPromptTitle, reactivateSubscriptionPromptMessage, reactivateSubscriptionAcceptButtonLabel, promptCancelButtonLabel } = displayText;
    const handleReactivate = async () => {
        onActionStarted();
        await reactivateSubscription(displayText);
        onActionFinished();
        hideModal();
    };
    if (!primaryCard)
        return null;
    const cardLastFourDigits = extractLastDigitsFromMaskedCardNumber(primaryCard.cardDetails.maskedCardNumber, 4);
    return (_jsx(ConfirmationModal, { show: show, heading: reactivateSubscriptionPromptTitle, message: getFormattedMessage(reactivateSubscriptionPromptMessage, i18n, cardLastFourDigits, reactivationPrice), acceptLabel: reactivateSubscriptionAcceptButtonLabel, cancelLabel: promptCancelButtonLabel, onCancel: hideModal, onAccept: handleReactivate }));
});
MemberPaymentCardWalletReactivateModal.displayName = 'MemberPaymentCardWalletReactivateModal';
